import api from './axios';

export const getTools = () => api.get('/tools');
export const getActiveTools = () => api.get('/tools/active');
export const createTool = (data) => api.post('/tools', data);
export const updateTool = (id, data) => api.put(`/tools/${id}`, data);
export const syncAllCharges = () => api.post('/tools/sync-charges');
